import { render, staticRenderFns } from "./CTA.vue?vue&type=template&id=31e2b0b8&scoped=true&"
import script from "./CTA.vue?vue&type=script&lang=ts&"
export * from "./CTA.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31e2b0b8",
  null
  
)

export default component.exports